import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import { wrapDisplayName } from 'recompose';
import { withRouter, withClient } from '@deerplusofficial/pos-hoc';
import { getResult, createCancelToken } from '@deerplusofficial/pos-helper';

export default () => Component =>
  fp.compose(
    withRouter(),
    withClient()
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryPointOfSales');

      static defaultProps = {
        channelId: PropTypes.string,
        client: PropTypes.shape(),
      };

      static defaultProps = {
        channelId: '',
        client: {},
      };

      state = {
        pointOfSales: null,
      };

      async componentDidMount() {
        this.onFetch();
      }

      componentWillUnmount() {
        !_.isUndefined(this.cancelFetch) && this.cancelFetch();
      }

      onFetch = async () => {
        const {
          channelId,
          client: { onError, POSApi },
        } = this.props;

        try {
          const { pointOfSales } = getResult(
            await POSApi.get(`/channels/${channelId}/point_of_sales`, {
              cancelToken: createCancelToken(this.cancelFetch),
            })
          );
          this.setState({ pointOfSales });
        } catch (e) {
          onError(e);
        }
      };

      render() {
        const { pointOfSales } = this.state;

        return (
          <Component
            pointOfSales={pointOfSales}
            onPointOfSalesRefetch={this.onFetch}
            {...this.props}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryPointOfSales.js